// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"422":"my","826":"index"}[chunkId] + "." + {"422":"0383cd6e","826":"b9bd5a56"}[chunkId] + ".css";
};